import type { BrandListApiResponse } from '@navio/nsdk';
import { URLKeys } from 'noddi-async';
import { type FilterOptionSource, usePagination } from 'noddi-ui-web';
import { useDebounceValue } from 'noddi-util';
import { toFilterOptionSource, useFilterOptionsGet } from '../useFilterOptionsGet';

/** Brands as filter options, searchable. For `unit.multiSelect`. */
export const useBrandOptions = ({
  serviceDepartmentIds,
  serviceOrganizationIds,
  hasEnabledAdapter
}: {
  serviceDepartmentIds?: number[];
  serviceOrganizationIds?: number[];
  /** Only brands with a service organization adapter enabled for the current env. */
  hasEnabledAdapter?: boolean;
} = {}): FilterOptionSource<number> => {
  const { pageIndex, pageSize, search, setSearch } = usePagination();
  const debouncedSearch = useDebounceValue({ value: search, delay: 300 });

  const query = useFilterOptionsGet({
    type: URLKeys.getPaginatedBrands,
    input: {
      pageIndex,
      pageSize,
      search: debouncedSearch,
      serviceDepartmentIds,
      serviceOrganizationIds,
      hasEnabledAdapter
    },
    queryConfig: { select: toBrandOptions }
  });

  return toFilterOptionSource(query, 'number', { search, onSearch: setSearch });
};

const toBrandOptions = ({ results }: BrandListApiResponse) =>
  results.map((brand) => ({ value: brand.id, label: brand.name, imageUrl: brand.logo?.url }));
